import { EDIT_ORDER_TABS, hiddenTabsForOrderType } from '../../../constants';

/**
 * Tabs the EditOrderModal renders for an order. Order-type rules filter both a
 * caller-supplied list and the default one built from the order's shape.
 *
 * @param {Object} args
 * @param {string[]} [args.tabs] Candidate `EDIT_ORDER_TABS` (the import flow passes one).
 * @param {Object} args.order The order being edited.
 * @param {boolean} [args.showAdminTab] Include the admin tabs.
 * @param {boolean} [args.showAdminRatesTab] Include the admin rates tabs when the admin tab is off.
 * @param {boolean} [args.isServiceCallback] Hide ITEMS and HAUL_AWAY.
 * @param {boolean} [args.showServicesTab] Allow the SERVICES tab.
 * @returns {string[]} The `EDIT_ORDER_TABS` values to render, in order.
 */
export const resolveEditOrderTabs = ({
    tabs,
    order,
    showAdminTab,
    showAdminRatesTab,
    isServiceCallback,
    showServicesTab,
}) => {
    const orderType = order?.order_type;

    const candidates = tabs
        ? tabs
        : [
              EDIT_ORDER_TABS.ORDER_DETAILS,
              ...(showAdminTab
                  ? [EDIT_ORDER_TABS.ADMIN, EDIT_ORDER_TABS.ADMIN_NOTES, EDIT_ORDER_TABS.NOTIFICATIONS]
                  : showAdminRatesTab
                  ? [EDIT_ORDER_TABS.ADMIN_RATES, EDIT_ORDER_TABS.ADMIN_NOTES, EDIT_ORDER_TABS.NOTIFICATIONS]
                  : []),
              ...(order?.has_middle_mile_origin ? [EDIT_ORDER_TABS.ORIGIN] : []),
              ...(!order?.is_middle_mile || order.carrier_id ? [EDIT_ORDER_TABS.PICKUP] : []),
              EDIT_ORDER_TABS.CUSTOMER,
              EDIT_ORDER_TABS.ITEMS,
              EDIT_ORDER_TABS.SERVICES,
              EDIT_ORDER_TABS.HAUL_AWAY,
              ...(!showAdminTab ? [EDIT_ORDER_TABS.NOTES] : []),
              EDIT_ORDER_TABS.WAREHOUSE,
          ];

    const hiddenTabs = hiddenTabsForOrderType(orderType);

    return candidates.filter((tab) => {
        // ITEMS / HAUL_AWAY don't apply to service-callback orders; SERVICES owns editing.
        if (isServiceCallback && (tab === EDIT_ORDER_TABS.ITEMS || tab === EDIT_ORDER_TABS.HAUL_AWAY)) {
            return false;
        }
        // SERVICES tab only renders for customers with service definitions configured.
        if (tab === EDIT_ORDER_TABS.SERVICES && !showServicesTab) return false;
        // Consigneeless / customerless order types hide their irrelevant tabs.
        if (hiddenTabs.includes(tab)) return false;
        return true;
    });
};
